import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';


// Pages
import Login from './pages/Login';
import SuperAdminDashboard from './pages/SuperAdminDashboard';
import DistrictAdminDashboard from './pages/DistrictAdminDashboard';
import ClubAdminDashboard from './pages/ClubAdminDashboard';
import MemberDashboard from './pages/MemberDashboard';
import AttendanceForm from './pages/AttendanceForm';
import AttendanceSuccess from './pages/AttendanceSuccess';
import RegisterClub from './pages/RegisterClub';

import { Toaster } from 'react-hot-toast';

function App() {
  return (
    <Router>
      <Toaster position="bottom-center" reverseOrder={false} />
      <Routes>
        <Route path="/" element={<Login />} />
        <Route path="/login" element={<Login />} />
        <Route path="/super-admin" element={<SuperAdminDashboard />} />
        <Route path="/district-admin" element={<DistrictAdminDashboard />} />
        <Route path="/club-admin" element={<ClubAdminDashboard />} />
        <Route path="/member-dashboard" element={<MemberDashboard />} />
        <Route path="/attendance/:token" element={<AttendanceForm />} />
        <Route path="/attendance-success" element={<AttendanceSuccess />} />
        <Route path="/register-club" element={<RegisterClub />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </Router>
  );
}

export default App;
